import { makeStyles } from "@material-ui/core";
import MuICallMadeIcon from "@material-ui/icons/CallMade";
import React from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: 20,
    height: 20,
    padding: 10,
    borderRadius: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
  },
}));

function CallMadeIcon() {
  const classes = useStyles();

  return <MuICallMadeIcon className={classes.icon} />;
}

export function InfoIcon() {
  const classes = useStyles();

  return (
    <span className={classes.icon} style={{ fontSize: 16, fontWeight: "bold" }}>
      i
    </span>
  );
}

export default CallMadeIcon;
